import React, { useState, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import CardAjustavel from '~/Components/CardAjustavel';
import './style.css';
import AuthStorage from '~/Utils/AuthStorage';
import { BASE_IMG_URL } from '~/Utils/Helpers';
import { registrarSaqueFundoPj } from '~/Services/Service';
import { CARACTERISTICA_RELATORIO_DEBITOS_MUNICIPAIS } from '~/constant';

const HubRelatorios = function() {
  const [pesquisa, setPesquisa] = useState('');

  const verificarAcesso = function(relatorio) {
    if (relatorio.IsVisivel) {
      return relatorio.IsVisivel();
    }
    return true;
  };

  var relatorios = [
    {
      title: 'Ranking Vendas',
      href: '/comercial/relatorio/ranking-vendas',
      src: BASE_IMG_URL + 'medal.svg',
      descricao:
        'Visualize e/ou realize download do relatório de ranking de vendas.',
      IsVisivel: function() {
        return AuthStorage.isADM() || AuthStorage.isGerente();
      },
    },
    {
      title: 'Vendas por Empreendimento',
      href: '/comercial/relatorio/vendas-empreendimento',
      src: BASE_IMG_URL + 'payment_envelope.svg',
      descricao:
        'Visualize graficamente o ranking de vendas por empreendimento.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([199, 459, 201, 279]);
      },
    },
    {
      title: 'Vendas por Imobiliária',
      href: '/relatorio/vendas-imobiliaria',
      src: BASE_IMG_URL + 'building_chart.svg',
      descricao:
        'Visualize graficamente o ranking de vendas por imobiliária e corretores.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([199, 459, 201, 279]);
      },
    },
    {
      title: 'Vendas por Trimestre',
      href: '/comercial/relatorio/vendas-trimestre',
      src: BASE_IMG_URL + 'graph_bar.svg',
      descricao:
        'VGV por trimestre, VSO do trimestre, total de vendas e comparativo.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([279, 201]);
      },
    },
    {
      title: 'Vendas por Valor à Vista',
      href: '/relatorios/vendas-valor-vista',
      src: BASE_IMG_URL + 'payment_envelope.svg',
      descricao:
        'Relatório gerencial de vendas agrupado por valor à vista (VV), com filtros por empreendimento, período e hierarquia comercial.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(630) && AuthStorage.temCaracteristica(20);
      },
    },
    {
      title: 'Fluxo de Caixa',
      href: '/relatorios/fluxo-de-caixa',
      src: BASE_IMG_URL + 'payment_envelope.svg',
      descricao:
        'Painéis de fluxo de caixa com filtros por Soc.%, período, GE, empreendimento, cobrança e tipo de parcela.',
        IsVisivel: function(){
          return AuthStorage.temCaracteristicas([730])
        }
    },
    {
      title: 'Boletos vencidos não enviados',
      href: '/imob/relatorios/boletos-nao-enviados',
      src: BASE_IMG_URL + 'late_payment.svg',
      descricao:
        'Boletos vencidos cuja remessa bancária ainda não foi enviada (Incorporadora + Imobiliária), com subtotais por empreendimento e exportação Excel.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(630) && AuthStorage.temCaracteristica(194);
      },
    },
    {
      title: 'Vendas com Desconto',
      href: '/relatorio-vendas-desconto',
      src: BASE_IMG_URL + 'tag_sale.svg',
      descricao:
        'Identifica pré-vendas com desconto sobre o valor de tabela, por empreendimento e período, com exportação Excel.',
    },
    {
      title: 'Comissão Corretor',
      href: '/comercial/relatorio/comissao-corretor',
      src: BASE_IMG_URL + 'commission.svg',
      descricao:
        'Visualize e/ou realize download do relatório de comissão de vendas.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(223);
      },
    },
    {
      title: 'Débitos/Créditos',
      href: '/comercial/relatorio/debitos-creditos',
      src: BASE_IMG_URL + 'late_payment.svg',
      descricao: 'Visualize o relatório de débito e crédito por corretor.',
      IsVisivel: function() {
        return (
          AuthStorage.isCorretor() || AuthStorage.temCaracteristicas([224, 201])
        );
      },
    },
    {
      title: 'Estoque',
      href: '/comercial/relatorio/relatorio-estoque',
      src: BASE_IMG_URL + 'stock_graph.svg',
      descricao:
        'Estoque disponível por Status, Tipologia, Empreendimento ou Cidade.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(201);
      },
    },
    {
      title: 'Cadastros / Pastas',
      href: '/comercial/relatorio/prospectos-pastas',
      src: BASE_IMG_URL + 'files.svg',
      descricao: 'Ranking de cadastros de clientes e pastas por imobiliária.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([199, 459, 201]);
      },
    },
    {
      title: 'Pesquisa Prospecto',
      href: '/comercial/relatorio/pesquisa-prospecto',
      src: BASE_IMG_URL + 'target_person.svg',
      descricao: 'Respostas do corretor no cadastro de prospecto.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(201) || AuthStorage.isADM();
      },
    },
    {
      title: 'Conversão de Leads',
      href: '/relatorio/conversao/leads',
      src: BASE_IMG_URL + 'partner.svg',
      descricao:
        'Visualize e/ou realize download do relatório de conversão de leads.',
      IsVisivel: function() {
        return (
          AuthStorage.temCaracteristicas([199, 459, 201]) ||
          AuthStorage.isCorretor()
        );
      },
    },
    {
      title: 'Motivos Não Compra',
      href: '/comercial/relatorio/motivos-nao-compra',
      src: BASE_IMG_URL + 'dissatisfied.svg',
      descricao:
        'Visualize e/ou realize download da lista de motivos de não compra.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(279);
      },
    },
    {
      title: 'Interesses por Lote',
      href: '/comercial/relatorio/interesses-por-lote',
      src: BASE_IMG_URL + 'target_person.svg',
      descricao:
        'Quantidade de prospectos interessados por lote do empreendimento.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(279);
      },
    },
    {
      title: 'Lançamento',
      href: '/comercial/relatorio/lancamento',
      src: BASE_IMG_URL + 'rocketDHB.svg',
      descricao: 'Visualize graficamente cada etapa do cliente no lançamento.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(279);
      },
    },
    {
      title: 'Fila do Lote',
      href: '/comercial/relatorio/fila-lote',
      src: BASE_IMG_URL + 'clock.svg',
      descricao: 'Visualize o relatório de reservas e filas do lote.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(279);
      },
    },
    {
      title: 'Atendimento Lançamento',
      href: '/comercial/relatorio/atendimento-lancamento',
      src: BASE_IMG_URL + 'calling.svg',
      descricao: 'Visualize o relatório de atendimentos do lançamento.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(279);
      },
    },
    {
      title: 'Visão Lançamento',
      href: '/comercial/relatorio/visao-lancamento',
      src: BASE_IMG_URL + 'calling.svg',
      descricao:
        'Painel executivo do evento: atendimentos, vendas, segmentação e motivos.',
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
    },
    {
      title: 'Estornos',
      href: '/comercial/relatorio/estorno',
      src: BASE_IMG_URL + 'late_payment.svg',
      descricao: 'Visualize o relatório de estornos.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([201, 199, 459]);
      },
    },
    {
      title: 'Alçadas de Desconto',
      href: '/comercial/relatorio/alcadas',
      src: BASE_IMG_URL + 'tag_sale.svg',
      descricao: 'Alçadas de desconto e carência dos corretores e gerentes.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([201, 459, 199]);
      },
    },
    {
      title: 'Pesquisa Pós-Venda',
      href: '/comercial/relatorio/posvenda',
      src: BASE_IMG_URL + 'contract_approve.svg',
      descricao: 'Visualize a pesquisa pós-venda.',
      IsVisivel: function() {
        return (
          AuthStorage.temCaracteristicas([201, 459, 199, 18]) ||
          AuthStorage.isADM()
        );
      },
    },
    {
      title: 'Processos Judiciais',
      href: '/relatorio/processos-judiciais',
      src: BASE_IMG_URL + 'auction-hammer.svg',
      descricao:
        'Visualize e/ou realize download do relatório de processos judiciais.',
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
    },
    {
      title: 'Produtividade',
      href: '/comercial/relatorio/produtividade',
      src: BASE_IMG_URL + 'increasing_chart.svg',
      descricao: 'Visualize graficamente a produtividade por corretor.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(518);
      },
    },
    {
      title: 'Produtividade Cobradores',
      href: '/comercial/relatorio/cobradores',
      src: BASE_IMG_URL + 'graph_pizza.svg',
      descricao: 'Visualize graficamente a produtividade dos cobradores.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([567, 568]);
      },
    },
    {
      title: 'Escalas',
      href: '/relatorio/escalas',
      src: BASE_IMG_URL + 'settings_bussines.svg',
      descricao: 'Visualize graficamente as escalas de trabalho.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(577);
      },
    },
    {
      title: 'Inatividade Leads',
      href: '/comercial/relatorio/leads/inatividade',
      src: BASE_IMG_URL + 'times_sand.svg',
      descricao:
        'Visualize e/ou realize download do relatório de inatividade dos leads.',
      IsVisivel: function() {
        return AuthStorage.isADM() || AuthStorage.isGerente();
      },
    },
    {
      title: 'Auto Atendimento',
      href: '/relatorio/auto-atendimento',
      src: BASE_IMG_URL + 'lead_configuration.svg',
      descricao:
        'Visualize e/ou realize download do relatório de auto atendimento.',
      IsVisivel: function() {
        return AuthStorage.isADM() || AuthStorage.isGerente();
      },
    },
    {
      title: 'Gestão de Rescisões',
      href: '/relatorio/gestao-rescisoes',
      src: BASE_IMG_URL + 'cancel_contract.svg',
      descricao:
        'Visualize e/ou realize download do relatório de gestão de rescisões.',
      IsVisivel: function() {
        return AuthStorage.isADM() || AuthStorage.isGerente();
      },
    },
    {
      title: 'Rescisões',
      href: '/comercial/relatorio/rescisoes',
      src: BASE_IMG_URL + 'cancel_contract.svg',
      descricao:
        'Detalhamento de rescisões por período, com valores de sinal, financiamento e motivo.',
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
    },
    {
      title: 'Imóveis Rescindidos',
      href: '/relatorio/imoveis-rescindidos',
      src: BASE_IMG_URL + 'cancel_contract.svg',
      descricao:
        'Relatório detalhado de imóveis rescindidos com filtros avançados e exportação Excel.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristica(630) && (AuthStorage.isADM() || AuthStorage.isGerente());
      },
    },
    {
      title: 'Leads x Vendas',
      href: '/relatorio/leads-vendas',
      src: BASE_IMG_URL + 'handshake.svg',
      descricao:
        'Visualize e/ou realize download do relatório de leads x vendas.',
      IsVisivel: function() {
        return AuthStorage.isADM() || AuthStorage.isGerente();
      },
    },
    {
      title: 'Conferência de Vendas',
      href: '/relatorio/conferencia',
      src: BASE_IMG_URL + 'graph_pizza.svg',
      descricao: 'Visualize o relatório de conferência.',
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
    },
    {
      title: 'Leads Guarulhos WF2',
      href: '/comercial/relatorio/enquadramento-guarulhos',
      src: BASE_IMG_URL + 'graph_pizza.svg',
      descricao:
        'Visualize a distribuição dos clientes e renda do Setparque Work Fire 2 (Guarulhos).',
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
    },
    {
      title: 'Controle de brindes',
      href: '/comercial/controle-brindes  ',
      src: BASE_IMG_URL + 'gift.svg',
      descricao: 'Visualize e/ou opere o relatório de controle de brindes.',
      /*
      IsVisivel: function() {
        return AuthStorage.isADM();
      },
      */
    },
    {
      title: 'Cidades',
      href: '/comercial/relatorio/cidades',
      src: BASE_IMG_URL + 'building.svg',
      descricao:
        'Listagem de cidades cadastradas com filtros por estado e nome, ordenação configurável e exportação para Excel.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([19]);
      },
    },
    {
      // W-0491 — Lista de Ocorrências de Contas (admin-only; Gate 1B Q-01=E)
      title: 'Ocorrências de Contas',
      href: '/ges/relatorios/contas/ocorrencias',
      src: BASE_IMG_URL + 'building.svg',
      descricao:
        'Listagem de ocorrências de contas por período, com filtros por grupo de empresa, usuário, empreendimento, cliente e título, e exportação para Excel.',
      IsVisivel: () => {
        return AuthStorage.temCaracteristica(630) && AuthStorage.isADM();
      },
    },
    {
      title: 'Despesa por Departamento',
      href: '/relatorios/despesa-depto',
      src: BASE_IMG_URL + 'graph_pizza.svg',
      descricao: 'Relatório gerencial de despesas distribuídas por departamento, com pivot mensal e exportação Excel/PDF.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([21]);
      },
    },
    {
      title: 'Variantes do Ativo',
      href: '/relatorios/variantes-ativo',
      src: BASE_IMG_URL + 'building_chart.svg',
      descricao: 'Listagem de variantes de ativos com filtro por código ou nome, com exportação para Excel.',
      IsVisivel: function() {
        return AuthStorage && AuthStorage.temCaracteristicas([630]);
      }
    },
    {
      title: 'Alínea de Títulos',
      href: '/ges/relatorios/titulos/alinea',
      src: BASE_IMG_URL + 'graph_pizza.svg',
      descricao: 'Relatório gerencial de alíneas de títulos, com filtros por código e descrição, contém exportação Excel/PDF.',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([630]);
      },
    },
    {
      title: 'Contratos com Alienação Fiduciária',
      href: '/relatorios/contratos/com-construcao',
      src: BASE_IMG_URL + 'building_chart.svg',
      descricao: 'Visualize o relátório de contratos marcados com construção',
      IsVisivel: function() {
        return AuthStorage.temCaracteristicas([630]);
      },
    },
    {
      title: 'Débitos Municipais',
      href: '/relatorios/relatorio-debitos-municipais',
      src: BASE_IMG_URL + 'late_payment.svg',
      descricao:
        'Relatório de débitos municipais por GE e família, com filtros de período e opção de último boleto.',
      IsVisivel: () =>
        AuthStorage.temCaracteristica(
          CARACTERISTICA_RELATORIO_DEBITOS_MUNICIPAIS
        ),
    },
  ];

  const relatoriosFiltrados = useMemo(
    function() {
      var comAcesso = relatorios.filter(function(relatorio) {
        return verificarAcesso(relatorio);
      });
      if (!pesquisa.trim()) {
        return comAcesso;
      }
      var termo = pesquisa.toLowerCase().trim();
      return comAcesso.filter(function(relatorio) {
        var matchTitulo = relatorio.title.toLowerCase().indexOf(termo) !== -1;
        var matchDescricao =
          relatorio.descricao.toLowerCase().indexOf(termo) !== -1;
        return matchTitulo || matchDescricao;
      });
    },
    [pesquisa]
  );

  const handleCardClick = function(href) {
    window.location.href = href;
  };

  return (
    <Container fluid className="py-3">
      <HeaderAzul
        title="Relatórios"
        contemPesquisa={true}
        pesquisa={pesquisa}
        setPesquisa={setPesquisa}
        searchPlaceholder="Buscar relatório..."
      />
      <div className="hub-relatorios-container">
        {relatoriosFiltrados.length > 0 ? (
          relatoriosFiltrados.map(relatorio => {
            return (
              <CardAjustavel
                key={relatorio.href}
                src={relatorio.src}
                title={relatorio.title}
                subtitle={relatorio.descricao}
                widht="70px"
                height="70px"
                eventoClick={() => {
                  handleCardClick(relatorio.href);
                }}
              />
            );
          })
        ) : (
          <div className="hub-relatorios-empty">
            <p>Nenhum relatório encontrado para "{pesquisa}"</p>
          </div>
        )}
      </div>
    </Container>
  );
};

export default HubRelatorios;
